module.exports = __webpack_public_path__ + "static/img/xinnengyuan3.4dd96e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinnengyuan3.png
// module id = ANs6
// module chunks = 16